import React from 'react';

export interface SpeechkitConfig {
    ttsMessageLimit: number;
}

export default React.createContext<SpeechkitConfig>({ttsMessageLimit: 1});
